import { render, staticRenderFns } from "./monitorPointManagement.vue?vue&type=template&id=711d0e2c&scoped=true"
import script from "./monitorPointManagement.vue?vue&type=script&lang=js"
export * from "./monitorPointManagement.vue?vue&type=script&lang=js"
import style0 from "./monitorPointManagement.vue?vue&type=style&index=0&id=711d0e2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711d0e2c",
  null
  
)

export default component.exports